import type { Site } from '../../domain/inventory';

export function sitesForCustomer(sites: Site[], customerId: string): Site[] {
  if (!customerId) return sites;
  return sites.filter((site) => site.customerId === customerId);
}

export function sitesForCustomers(sites: Site[], customerIds: readonly string[]): Site[] {
  if (customerIds.length === 0) return sites;
  return sites.filter((site) => customerIds.includes(site.customerId));
}
